import { useLanguage } from '@/contexts/LanguageContext';
import {
  MockApplicationsScores,
  MockBrandedCareerPage,
  MockInterviewReport,
  MockPositionsOverview,
} from './MarketingProductMocks';
import { cn } from '@/lib/utils';

/** Bento-style product previews for the contact page. */
export function MarketingContactCollage({ className }: { className?: string }) {
  const { t } = useLanguage();

  return (
    <div className={cn('space-y-4', className)}>
      <p className="text-sm text-muted-foreground leading-relaxed max-w-md">
        {t('marketing.contact.visualIntro')}
      </p>
      <div className="grid grid-cols-2 gap-3 md:gap-4">
        <div className="col-span-2 scale-[0.92] origin-top-left">
          <MockPositionsOverview />
        </div>
        <div className="scale-[0.88] origin-top">
          <MockApplicationsScores />
        </div>
        <div className="scale-[0.88] origin-top translate-y-2">
          <MockBrandedCareerPage />
        </div>
        <div className="col-span-2 scale-[0.9] origin-top">
          <MockInterviewReport caption={t('marketing.contact.visualCaption')} />
        </div>
      </div>
    </div>
  );
}
